module.exports = __webpack_public_path__ + "img/light-icon.de2c1fda.png";